import Blazy = require('blazy');
import $ from './gs-zepto';

const success = () => $(window).trigger('resize').trigger('scroll');
const blazy = new Blazy({ success });

export default blazy;
